import { create } from 'zustand';
import { shipmentApi } from '@/lib/api';

export interface InboundShipmentItem {
  id: number;
  order_id: number;
  currency_id: number;
  marketplace_id: number;
  marketplace_product_id: number;
  reference_item_id: string;
  shipment_id: number | null;
  order_product_waybill_id: number;
  order_product_completion_id: number | null;
  code: string;
  first_identifier: string;
  second_identifier: string;
  sku: string;
  mkt_sku: string | null;
  weight: string;
  ai_weight: string | null;
  mkt_weight: string | null;
  customer_selected_category: string | null;
  price: string;
  qty: number;
  is_cancelled: number;
  refund_date: string | null;
  refund_amount: string | null;
  refund_method: string | null;
  refund_giftcard_id: string | null;
  refund_reason: string | null;
  refund_note: string | null;
  subtotal: string;
  shipping: string;
  mkt_shipping_fee: string | null;
  tax: string;
  mahalkum_fee: string;
  discount_price: number;
  total: string;
  send_to_trakpylot: number;
  product_image: string;
  created_at: string;
  updated_at: string;
  mkt_fee_applied: string | null;
  mkt_tax_included: string | null;
  master_way_bill: string;
  carrier_name: string | null;
  shipment_created_at: string | null;
  marketplace_product_name: string;
  marketplace_order_number: string | null;
  marketplace_name: string;
  marketplace_url: string;
  originator_tracking_no: string | null;
  order_confirmed: string | null;
  shipment_reference: string;
}

interface InboundShipmentItemsState {
  items: InboundShipmentItem[];
  isLoading: boolean;
  error: string | null;
  fetchItems: (args: {
    token: string;
    storeId: number;
    shipmentId: number;
    shipmentReference?: string;
    masterWayBill?: string;
  }) => Promise<void>;
  reset: () => void;
}

export const useInboundShipmentItemsStore = create<InboundShipmentItemsState>((set) => ({
  items: [],
  isLoading: false,
  error: null,

  async fetchItems({ token, storeId, shipmentId, shipmentReference, masterWayBill }) {
    set({ isLoading: true, error: null });
    try {
      const res = await shipmentApi.getShipmentItems(token, storeId, shipmentId, {
        shipmentReference,
        masterWayBill,
      });
      if (!res.success) {
        throw new Error(res.message || 'Failed to fetch shipment items');
      }
      const data = Array.isArray(res.data) ? res.data : [];
      set({ items: data });
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Failed to fetch shipment items';
      set({ error: msg, items: [] });
    } finally {
      set({ isLoading: false });
    }
  },

  reset() {
    set({ items: [], isLoading: false, error: null });
  },
}));


